import { render, staticRenderFns } from "./bookingList.vue?vue&type=template&id=fc235ccc&scoped=true"
import script from "./bookingList.vue?vue&type=script&lang=js"
export * from "./bookingList.vue?vue&type=script&lang=js"
import style0 from "./bookingList.vue?vue&type=style&index=0&id=fc235ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc235ccc",
  null
  
)

export default component.exports